export default "__VITE_ASSET__edf24e11__"